// Проверка версии фронтенда: после деплоя нового билда меняется
// version.json в корне публичной директории. Клиент периодически
// сверяет хеш и принудительно перезагружается при несовпадении —
// это страхует от залипшего кеша index.html (особенно в Safari).

const CURRENT_HASH = process.env.VUE_APP_BUILD_HASH || ''
const CHECK_INTERVAL_MS = 60 * 1000
const VERSION_URL = `${process.env.BASE_URL || '/'}version.json`

let timerId = null
let reloading = false

async function fetchRemoteHash() {
  try {
    const response = await fetch(`${VERSION_URL}?_=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'omit',
    })
    if (!response.ok) return null
    const data = await response.json()
    return data && data.hash ? String(data.hash) : null
  } catch (e) {
    return null
  }
}

async function checkVersion() {
  if (reloading || !CURRENT_HASH) return
  const remoteHash = await fetchRemoteHash()
  if (!remoteHash) return
  if (remoteHash !== CURRENT_HASH) {
    reloading = true
    // Жёсткая перезагрузка: сбрасываем кешированный index.html и чанки
    window.location.reload(true)
  }
}

export function startVersionCheck() {
  if (process.env.NODE_ENV !== 'production') return
  if (!CURRENT_HASH) return
  if (timerId) return

  timerId = setInterval(checkVersion, CHECK_INTERVAL_MS)

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkVersion()
  })

  window.addEventListener('focus', checkVersion)
}
